export const nlMobileAppDevelopment = {
  title: "Professionele Mobiele App Ontwikkeling",
  description: "Maatwerk mobiele applicaties ontworpen voor prestaties, schaalbaarheid en uitstekende gebruikerservaringen op alle apparaten.",
  subtitle: "Oplossingen voor Mobiele App Ontwikkeling",

  servicesTitle: "Onze Mobiele Ontwikkelingsexpertise",
  servicesSubtitle: "Uitgebreide oplossingen afgestemd op uw zakelijke behoeften",
  services: {
    ios: {
      title: "iOS App Ontwikkeling",
      description: "Native iOS-applicaties gebouwd met moderne frameworks voor een naadloze Apple-ervaring.",
      technologies: ["Swift", "SwiftUI", "UIKit", "Core Data", "ARKit"]
    },
    android: {
      title: "Android App Ontwikkeling",
      description: "Native Android-applicaties geoptimaliseerd voor diverse apparaten en schermformaten.",
      technologies: ["Kotlin", "Jetpack Compose", "Android SDK", "Room DB", "Material Design"]
    },
    hybrid: {
      title: "Hybride App Ontwikkeling",
      description: "Cross-platform oplossingen die werken op iOS en Android met één codebase.",
      technologies: ["Ionic", "Capacitor", "Cordova", "HTML5", "CSS3"]
    },
    crossPlatform: {
      title: "Cross-Platform Ontwikkeling",
      description: "Native-achtige prestaties op alle platforms met moderne frameworks.",
      technologies: ["Flutter", "React Native", "Dart", "JavaScript", "Redux"]
    },
    uiux: {
      title: "Mobiele UI/UX Design",
      description: "Intuïtieve interfaces speciaal ontworpen voor mobiele interacties en ervaringen.",
      technologies: ["Figma", "Adobe XD", "Material Design", "Human Interface", "Prototyping"]
    },
    maintenance: {
      title: "App Onderhoud & Support",
      description: "Doorlopende updates en optimalisaties om uw app optimaal te laten presteren.",
      technologies: ["Bugfixing", "Performance Tuning", "Beveiligingsupdates", "API Updates", "Store Compliance"]
    }
  },

  processTitle: "Ons App Ontwikkelingsproces",
  processSteps: [
    {
      title: "Ontdekking & Planning",
      description: "We analyseren uw wensen en maken een gedetailleerde roadmap voor de mobiele app."
    },
    {
      title: "UI/UX Design",
      description: "Mobielgerichte interfaces en naadloze gebruikerservaringen creëren."
    },
    {
      title: "Ontwikkeling",
      description: "Agile implementatie met regelmatige builds en testiteraties."
    },
    {
      title: "Kwaliteitsborging",
      description: "Grondige tests op apparaten, OS-versies en prestatiecriteria."
    },
    {
      title: "Uitrol",
      description: "App store-indiening en lanceringstrategie uitvoeren."
    },
    {
      title: "Ondersteuning na Lancering",
      description: "Doorlopende updates, functieverbeteringen en prestatiemonitoring."
    }
  ]
};

export const deMobileAppDevelopment = {
  title: "Professionelle Mobile App Entwicklung",
  description: "Individuell entwickelte mobile Anwendungen für Leistung, Skalierbarkeit und außergewöhnliche Nutzererlebnisse auf allen Geräten.",
  subtitle: "Lösungen für Mobile App Entwicklung",

  servicesTitle: "Unsere Mobile Entwicklungsexpertise",
  servicesSubtitle: "Umfassende Lösungen, zugeschnitten auf Ihre Geschäftsanforderungen",
  services: {
    ios: {
      title: "iOS App Entwicklung",
      description: "Native iOS-Apps mit modernen Frameworks für ein nahtloses Apple-Ökosystem.",
      technologies: ["Swift", "SwiftUI", "UIKit", "Core Data", "ARKit"]
    },
    android: {
      title: "Android App Entwicklung",
      description: "Native Android-Apps, optimiert für verschiedene Geräte und Bildschirmgrößen.",
      technologies: ["Kotlin", "Jetpack Compose", "Android SDK", "Room DB", "Material Design"]
    },
    hybrid: {
      title: "Hybride App Entwicklung",
      description: "Plattformübergreifende Lösungen, die auf iOS und Android mit einer einzigen Codebasis funktionieren.",
      technologies: ["Ionic", "Capacitor", "Cordova", "HTML5", "CSS3"]
    },
    crossPlatform: {
      title: "Cross-Platform Entwicklung",
      description: "Native-ähnliche Leistung auf allen Plattformen mit modernen Frameworks.",
      technologies: ["Flutter", "React Native", "Dart", "JavaScript", "Redux"]
    },
    uiux: {
      title: "Mobile UI/UX Design",
      description: "Intuitive Oberflächen, speziell für mobile Interaktionen und Erlebnisse gestaltet.",
      technologies: ["Figma", "Adobe XD", "Material Design", "Human Interface", "Prototyping"]
    },
    maintenance: {
      title: "App Wartung & Support",
      description: "Laufende Updates und Optimierungen, damit Ihre App stets optimal funktioniert.",
      technologies: ["Fehlerbehebung", "Performance Tuning", "Sicherheitsupdates", "API Updates", "Store Compliance"]
    }
  },

  processTitle: "Unser App Entwicklungsprozess",
  processSteps: [
    {
      title: "Entdeckung & Planung",
      description: "Wir analysieren Ihre Anforderungen und erstellen eine detaillierte Roadmap für die mobile App."
    },
    {
      title: "UI/UX Design",
      description: "Mobile-first Oberflächen und nahtlose Nutzererlebnisse gestalten."
    },
    {
      title: "Entwicklung",
      description: "Agile Umsetzung mit regelmäßigen Builds und Testiterationen."
    },
    {
      title: "Qualitätssicherung",
      description: "Strenge Tests auf Geräten, OS-Versionen und Leistungskriterien."
    },
    {
      title: "Bereitstellung",
      description: "App Store-Einreichung und Umsetzung der Launch-Strategie."
    },
    {
      title: "Support nach dem Launch",
      description: "Laufende Updates, Funktionsverbesserungen und Leistungsüberwachung."
    }
  ]
};
export const enMobileAppDevelopment = {
  // Hero Section
  title: "Professional Mobile App Development Services",
  description: "Custom-built mobile applications designed for performance, scalability, and exceptional user experiences across all devices.",
  subtitle: "Mobile App Development Solutions",

  // Services Section
  servicesTitle: "Our Mobile Development Expertise",
  servicesSubtitle: "Comprehensive solutions tailored to your business needs",
  services: {
    ios: {
      title: "iOS App Development",
      description: "Native iOS applications built with modern frameworks for seamless Apple ecosystem experiences.",
      technologies: ["Swift", "SwiftUI", "UIKit", "Core Data", "ARKit"]
    },
    android: {
      title: "Android App Development",
      description: "Native Android applications optimized for diverse devices and screen sizes.",
      technologies: ["Kotlin", "Jetpack Compose", "Android SDK", "Room DB", "Material Design"]
    },
    hybrid: {
      title: "Hybrid App Development",
      description: "Cross-platform solutions that work across iOS and Android with a single codebase.",
      technologies: ["Ionic", "Capacitor", "Cordova", "HTML5", "CSS3"]
    },
    crossPlatform: {
      title: "Cross-Platform Development",
      description: "Native-like performance across platforms using modern frameworks.",
      technologies: ["Flutter", "React Native", "Dart", "JavaScript", "Redux"]
    },
    uiux: {
      title: "Mobile UI/UX Design",
      description: "Intuitive interfaces designed specifically for mobile interactions and experiences.",
      technologies: ["Figma", "Adobe XD", "Material Design", "Human Interface", "Prototyping"]
    },
    maintenance: {
      title: "App Maintenance & Support",
      description: "Ongoing updates and optimizations to keep your app performing at its best.",
      technologies: ["Bug Fixing", "Performance Tuning", "Security Updates", "API Updates", "Store Compliance"]
    }
  },

  // Process Section
  processTitle: "Our App Development Process",
  processSteps: [
    {
      title: "Discovery & Planning",
      description: "We analyze your requirements and create a detailed mobile app roadmap."
    },
    {
      title: "UI/UX Design",
      description: "Creating mobile-first interfaces and seamless user experiences."
    },
    {
      title: "Development",
      description: "Agile implementation with regular builds and testing iterations."
    },
    {
      title: "Quality Assurance",
      description: "Rigorous testing across devices, OS versions, and performance metrics."
    },
    {
      title: "Deployment",
      description: "App store submission and launch strategy implementation."
    },
    {
      title: "Post-Launch Support",
      description: "Ongoing updates, feature enhancements, and performance monitoring."
    }
  ]
};



export const frMobileAppDevelopment = {
  title: "Services Professionnels de Développement d'Applications Mobiles",
  description: "Applications mobiles sur mesure conçues pour la performance, l'évolutivité et des expériences utilisateur exceptionnelles sur tous les appareils.",
  subtitle: "Solutions de Développement d'Applications Mobiles",

  servicesTitle: "Notre Expertise en Développement Mobile",
  servicesSubtitle: "Solutions complètes adaptées aux besoins de votre entreprise",
  services: {
    ios: {
      title: "Développement d'Applications iOS",
      description: "Applications iOS natives construites avec des frameworks modernes pour des expériences fluides dans l'écosystème Apple.",
      technologies: ["Swift", "SwiftUI", "UIKit", "Core Data", "ARKit"]
    },
    android: {
      title: "Développement d'Applications Android",
      description: "Applications Android natives optimisées pour divers appareils et tailles d'écran.",
      technologies: ["Kotlin", "Jetpack Compose", "Android SDK", "Room DB", "Material Design"]
    },
    hybrid: {
      title: "Développement d'Applications Hybrides",
      description: "Solutions multiplateformes qui fonctionnent sur iOS et Android avec une seule base de code.",
      technologies: ["Ionic", "Capacitor", "Cordova", "HTML5", "CSS3"]
    },
    crossPlatform: {
      title: "Développement Multiplateforme",
      description: "Performances similaires à celles des applications natives sur plusieurs plateformes grâce à des frameworks modernes.",
      technologies: ["Flutter", "React Native", "Dart", "JavaScript", "Redux"]
    },
    uiux: {
      title: "Conception UI/UX Mobile",
      description: "Interfaces intuitives conçues spécifiquement pour les interactions et expériences mobiles.",
      technologies: ["Figma", "Adobe XD", "Material Design", "Human Interface", "Prototypage"]
    },
    maintenance: {
      title: "Maintenance et Support d'Applications",
      description: "Mises à jour et optimisations continues pour garantir des performances optimales de votre application.",
      technologies: ["Correction de Bugs", "Optimisation des Performances", "Mises à Jour de Sécurité", "Mises à Jour d'API", "Conformité aux Stores"]
    }
  },

  processTitle: "Notre Processus de Développement d'Applications",
  processSteps: [
    {
      title: "Découverte et Planification",
      description: "Nous analysons vos besoins et créons une feuille de route détaillée pour l'application mobile."
    },
    {
      title: "Conception UI/UX",
      description: "Création d'interfaces adaptées aux mobiles et d'expériences utilisateur fluides."
    },
    {
      title: "Développement",
      description: "Mise en œuvre agile avec des builds réguliers et des itérations de test."
    },
    {
      title: "Assurance Qualité",
      description: "Tests rigoureux sur différents appareils, versions d'OS et métriques de performance."
    },
    {
      title: "Déploiement",
      description: "Soumission à l'App Store et mise en œuvre de la stratégie de lancement."
    },
    {
      title: "Support Post-Lancement",
      description: "Mises à jour continues, améliorations des fonctionnalités et surveillance des performances."
    }
  ]
};
